import { Box, HStack, Icon, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { IFOKONYV_DISP, IPARTNER_KONTIR_FORM, TranKodMap } from "@coimbra-its/api.konyvelo";
import { CellProps, useWSysPage, useWSysPath, WSysHeaderButton, WSysPage, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useState } from "react";
import { APPICONS } from "../Icons";
import { useKonyveloApi } from "../store/konyvelo.api";


export const CELLS: CellProps<IFOKONYV_DISP>[] = [
    { 'title': 'Kód', elem: (row) => row.FOK_KOD, charWidth: 10 },
    { 'title': 'Megnevezés', elem: (row) => row.MEGN, charWidth: 30 },
];


export type IMissingFokKod = Omit<IPARTNER_KONTIR_FORM, 'FOK_KOD'>;

export interface MissingFokKodProps {
    missing: IMissingFokKod;
    onClosed: () => void;
}



export function MissingFokKod({ missing, onClosed }: MissingFokKodProps) {


    const [q, setQ] = useState('');
    const prefix = TranKodMap[missing.TRKOD]?.FOK_KOD_PREFIX || '';

    const api = useKonyveloApi();
    const [fokonyvGetRes, hub] = api.fokonyvGet.useData({ q: prefix + q });
    const fokKodok = fokonyvGetRes?.result || [];

    const [selected, setSelected] = useState<IFOKONYV_DISP>();

    const partnerKontirPost = api.partnerKontirPost.useAction();

    const doSave = () => {
        if (!selected)
            throw new Error('Válassz főkönyvi számot!');

        hub.tryCatch(async () => {
            await partnerKontirPost({ data: { ...missing, FOK_KOD: selected.FOK_KOD } });
            onClosed();
        });
    };


    const page = useWSysPage({
        title: 'Hiányzó főkönyvi szám', maxCols: 2, variant: 'popup', onClosed
    });

    return <WSysPage page={page} hubs={[hub]}
        tools={<HStack>
            <InputGroup size='sm' width='auto' >
                <InputLeftElement
                    pointerEvents='none'
                    children={<><Icon color='gray.300' as={APPICONS.Search} />{prefix}</>}
                />
                <Input
                    value={q}
                    onChange={(e) => setQ(e.currentTarget.value)}
                />
            </InputGroup>
            <WSysHeaderButton icon={<APPICONS.Save />} colorScheme="primary" isDisabled={!selected} onClick={() => doSave()} >Mentés</WSysHeaderButton>

        </HStack>}

    >
        <Box display='flex' flexDir='row' p={2} gap={2} bg='#8884'>
            <Box as='span'>TRTIP: {missing.TRTIP}</Box> / 
            <Box as='span'>TRKOD: {missing.TRKOD}</Box>
        </Box>

        <WSysVert mode="rest">
            <WSysTable
                rows={fokKodok}
                cells={CELLS}
                onRowSelect={row => setSelected(row)}
                selectedRow={selected}
            //noHead={true}
            >

            </WSysTable>
        </WSysVert>




    </WSysPage>;

}